module.exports = __webpack_public_path__ + "static/media/BOTON-SERVICES.99e80acd.png";